import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [currentView, setCurrentView] = useState('login');
  
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Estado compartido para filtrar solicitudes desde otros módulos
  const [solicitudFilterId, setSolicitudFilterId] = useState(null);

  // Igual, pero para abrir el detalle de un artículo desde otro módulo
  // (p.ej. al hacer click en un artículo ya cotizado)
  const [articuloFilterId, setArticuloFilterId] = useState(null);

  // Guardar vista actual
  const handleViewChange = (newView) => {
    setCurrentView(newView);
    setSidebarOpen(false);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const value = {
    currentView,
    handleViewChange,
    sidebarOpen,
    setSidebarOpen,
    toggleSidebar,
    solicitudFilterId,
    setSolicitudFilterId,
    articuloFilterId,
    setArticuloFilterId,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp debe usarse dentro de AppProvider');
  }
  return context;
};

export default AppContext;
